<template>
  <section class="sec-comment" >
    <header class="sec-home-titr sec-home-titr-comment" ref="titr">
      <h1 class="sec-home-titr__title sec-home-titr-comment__title" :class="{'active':showCommentTitle}">نظرات</h1>
    </header>
    <main class="container-comment">
      <slider-part :groupvalue="group" :datas="getCommentList">
        <template v-slot:default="slotProps">
          <div :class="['comment',{'active':showHoney}]" ref="comment">
            <div class="comment-content">
              <div class="comment__outer-container-image">
                <div class="comment__out-container-image">
                  <div class="comment__image">
                    <img
                      :src="require('../../public/image/comment/' + slotProps.slidercontent.img)"
                    />
                  </div>
                </div>
              </div>
              <div class="comment__name">
                <h5>{{ slotProps.slidercontent.name }}</h5>
              </div>
              <div class="comment__text">
                <p>{{ slotProps.slidercontent.text }}</p>
              </div>
            </div>
          </div>
        </template>
      </slider-part>
    </main>
  </section>
</template>

<script>
import sliderPart from "./Slider.vue";

export default {
  components: {
    sliderPart,
  },
  data() {
    return {
      group: 1,
      showCommentTitle:false,
      showHoney:false
    };
  },
  computed: {
    getCommentList() {
      return this.$store.getters.getCommentList;
    },
  },
  mounted(){
    let vh=window.innerHeight * 4 / 5;
    let vh2=window.innerHeight * 1 / 2;
    let titr=this.$refs.titr
    let comment=this.$refs.comment
  window.addEventListener('scroll',()=>{
    let topOfTitr=titr.getBoundingClientRect().top;
    let topOfComment=comment.getBoundingClientRect().top;
    if(topOfTitr<vh){
      this.showCommentTitle=true
    }
    if(topOfComment<vh2){
      this.showHoney=true
    }else if(topOfComment>window.innerHeight){
      this.showHoney=false
    }

  })
  }
};
</script>

<style></style>
